// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2IId1","topBottomGutter":"Layout_topBottomGutter__1ybsn"};